module.exports = __webpack_public_path__ + "static/second-e2daee6c5fefc7c3e891dc40c000f5e7.jpg";